/* eslint-disable no-empty */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

import { useEffect, useState } from 'react';

import { getInputFieldProps, parseNumericValue, pickProperties } from '../../../utils/common';
import { logger, safeString } from '../../../utils/logger';

import useAPIHandler from '../../../hook/use-api-handler';


import { useNavigate, useParams } from 'react-router-dom';
import { useToast } from '../../../context/toast-context';
import useSnackbar from '../../../hook/use-snakbar';
import { fetchDataWithPromiseAndStoreData } from '../../../utils/fetch-data';
import { BENEFICIARY_API, BENEFICIARY_FORM_FIELDS, BENEFICIARY_INITIAL_STATE } from './beneficiary-constant';
import { createNomineeAndBankDetailsSchema } from './beneficiary-validation';

const useOrganisationOwnershipService = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [resource, setResource] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null)
  const [createFormUpdateLoading, setCreateFormUpdateLoading] = useState(false);
  const [organisationBanking, setOrganisationBanking] = useState(
    structuredClone(BENEFICIARY_INITIAL_STATE)
  );
  const [previewURL, setPreviewURL] = useState(null);
  const [nomineeList, setnomineeList] = useState({});
  const [employeeBenificiaryInput, setEmployeeBenificiaryInput] = useState(
    structuredClone(BENEFICIARY_INITIAL_STATE)
  );
  const { id: employeeID } = useParams()
  const {
    snackbarVisible,
    snackbarMessage,
    openSnackbar,
    closeSnackbar,
    snackColor,
  } = useSnackbar();
  const { showToastMessage } = useToast();
  const handleClickOpen = (_, data) => {
    setErrors({});
    setEmployeeBenificiaryInput(data ? data : structuredClone(BENEFICIARY_INITIAL_STATE))
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  const { fetchData } = useAPIHandler();
  const [createUpdateLoading, setCreateUpdateLoading] = useState(false);

  const [errors, setErrors] = useState({});
  const [selectedNominee, setSelectedNominee] = useState(null)
  const [deleteDialogShow, setDeleteDialogShow] = useState(false);
  const handleOpenDeleteDialog = (data) => {
    setDeleteDialogShow(true);
    setSelectedNominee(data)
  }
  const handleCloseDeleteDialog = () => {
    setDeleteDialogShow(false);
  }
  const handleDeleteNomineeFn = async () => {
    setCreateFormUpdateLoading(true);
    try {
      const res = await fetchData({
        selectedNominee,
        ...BENEFICIARY_API.BENEFICIARY_DELETE,
        data: [],
        url: `${BENEFICIARY_API.BENEFICIARY_DELETE.url}/${employeeID}/delete/${selectedNominee}`
      });
      showToastMessage({ message: "Beneficiary Deleted successfully!" });
      setCreateFormUpdateLoading(false);

      // Fetch updated data and recalculate percentageremaingValue
      const promiseData = fetchDataWithPromiseAndStoreData(
        `${BENEFICIARY_API.BENEFICIARY_DELETE.url}/${employeeID}`
      );
      setResource(promiseData.wrapPromise);

      promiseData.promise.then(res => {
        const percentageremaingValue = 100 - (res?.data?.data?.nominees?.reduce(
          (prev, curr) => prev + parseNumericValue(curr?.percentage_of_benefit),
          0
        ) || 0);
        setnomineeList({ ...res?.data?.data, percentageremaingValue });
      });

      handleResetForm();
      handleCloseDeleteDialog();
    } catch (error) {
      if (error?.type === "JoiValidationError") {
        const errorsAll = {};
        error?.errors?.map((item) => {
          const { field, message } = item;
          errorsAll[field] = message;
        });

        showToastMessage({
          message:
            Object.keys(errorsAll).length > 0
              ? "Validation Error!"
              : "Something went wrong!",
          color: "danger",
        });
        setErrors(errorsAll);
      }

      if (error?.type === "GeneralError") {
        showToastMessage({
          message: error.message || "An unknown general error occurred.",
          color: "danger",
        });
      }
      setCreateFormUpdateLoading(false);
    }
  }

  const handleChangeFunction = (e, name) => {

    let value = e;
    if (e && e.target) {
      value = e.target.value;
    }
    if (
      BENEFICIARY_FORM_FIELDS[name].customOptions &&
      BENEFICIARY_FORM_FIELDS[name].customOptions?.formatValueFn
    ) {
      value = BENEFICIARY_FORM_FIELDS[name].customOptions?.formatValueFn(
        value,
        employeeBenificiaryInput
      );
    }

    setEmployeeBenificiaryInput((prevUser) => ({
      ...prevUser,
      [name]: value,
    }));

    const fieldSchema = createNomineeAndBankDetailsSchema.extract(name);
    const { error } = fieldSchema.validate(value, {
      context: {
        ...employeeBenificiaryInput,

        nomineeList,
        percentageremaingValue: parseNumericValue(nomineeList.percentageremaingValue)
      },
    });
    if (!error) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: undefined,
      }));
    }
  };

  function handleBlurFn(e, name) {
    let value = e;
    if (e && e.target) {
      value = e.target.value;
    }
    const fieldSchema = createNomineeAndBankDetailsSchema.extract(name);
    const { error } = fieldSchema.validate(value,

      {
        context: {
          ...employeeBenificiaryInput, nomineeList, percentageremaingValue: parseNumericValue(nomineeList.percentageremaingValue)
        },
      }
    );



    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error ? error.details[0].message : undefined,
    }));
  }

  const handleSubmitFn = async () => {
    setCreateFormUpdateLoading(true);
    const { error, value } = createNomineeAndBankDetailsSchema.validate(
      pickProperties(employeeBenificiaryInput, Object.keys(structuredClone(BENEFICIARY_INITIAL_STATE))),
      {
        abortEarly: false,
        context: {
          nomineeList,
          ...employeeBenificiaryInput,
          percentageremaingValue: parseNumericValue(nomineeList.percentageremaingValue)
        }
      }
    );
    let validationErrors = {};
    if (error && error?.details?.length > 0) {
      validationErrors = error.details.reduce((acc, err) => {
        const pathname = err.path.join(".");
        acc[pathname] = err.message;
        return acc;
      }, {});
    }
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setCreateFormUpdateLoading(false);
    } else {
      setErrors({});
      const data = new FormData();
      Object.keys(value).map((key) => {
        data.append(key, value[key] ?? "");
      });
      if (selectedFile) {
        data.append("employee_nominee_file", selectedFile);
      }
      const isEdit = !!employeeBenificiaryInput?.nominee_id;
      try {
        const apiConfig = isEdit
          ? {
            data,
            ...BENEFICIARY_API.BENEFICIARY_UPDATE,
            url: `${BENEFICIARY_API.BENEFICIARY_UPDATE.url}/${employeeID}/update/${employeeBenificiaryInput?.nominee_id}`,
          }
          : {
            data,
            ...BENEFICIARY_API.BENEFICIARY_CREATE,
            url: `${BENEFICIARY_API.BENEFICIARY_CREATE.url}/${employeeID}`,
          };
        const res = await fetchData(apiConfig);

        showToastMessage({
          message: isEdit
            ? "Beneficiary updated successfully!"
            : "Beneficiary added successfully!"
        });
        setCreateFormUpdateLoading(false);

        // const promiseData
        // setResource(fetchDataWithPromise(`${BENEFICIARY_API.BENEFICIARY_LIST.url}/${employeeID}`));
        const promiseData = fetchDataWithPromiseAndStoreData(
          `${BENEFICIARY_API.BENEFICIARY_LIST.url}/${employeeID}`
        );
        setResource(promiseData.wrapPromise);

        promiseData.promise.then(res => {
          const percentageremaingValue = 100 - res?.data?.data?.nominees?.reduce((prev, curr) => prev + parseNumericValue(curr?.percentage_of_benefit), 0)
          setnomineeList({ ...res?.data?.data, percentageremaingValue });

        })
        handleClose()

      } catch (error) {
        if (error?.type === "JoiValidationError") {
          const errorsAll = {};

          error?.errors?.map((item) => {
            const { field, message } = item;
            errorsAll[field] = message;
          });

          showToastMessage({
            message:
              Object.keys(errorsAll).length > 0
                ? "Validation Error!"
                : "Something went wrong!",
            color: "danger",
          });
          setErrors(errorsAll);
        }

        if (error?.type === "GeneralError") {
          showToastMessage({
            message: error.message || "An unknown general error occurred.",
            color: "danger",
          });
        }
        setCreateFormUpdateLoading(false);
      }
    }
  }

  function handleResetForm(data) {
    setEmployeeBenificiaryInput({ ...structuredClone(BENEFICIARY_INITIAL_STATE), ...data })
  }

  const getInputFieldPropsFn = (fieldName = "") => {
    // eslint-disable-next-line no-unused-vars
    const { customOptions = {}, ...restProps } =
      BENEFICIARY_FORM_FIELDS[fieldName] || {};
    const error = safeString(errors[fieldName]);
    const props = {
      ...restProps,
      ...getInputFieldProps({
        name: fieldName,
        stateValues: employeeBenificiaryInput,
        type: restProps.type || "text",
        error,
        handleChangeFunction,
        handleBlurFn
      }),
    };
    return props;
  };





  useEffect(() => {
    // Use cachedApiCall to fetch data and wrap it
    const promiseData = fetchDataWithPromiseAndStoreData(
      `${BENEFICIARY_API.BENEFICIARY_LIST.url}/${employeeID}`
    );
    setResource(promiseData.wrapPromise);

    promiseData.promise.then(res => {
      const percentageremaingValue = 100 - res?.data?.data?.nominees?.reduce((prev, curr) => prev + parseNumericValue(curr?.percentage_of_benefit), 0)
      setnomineeList({ ...res?.data?.data, percentageremaingValue });
      logger.log("percentageremaingValue", percentageremaingValue)
    })

  }, []);
  return {
    handleSubmitFn,
    getInputFieldPropsFn,
    employeeBenificiaryInput,
    createUpdateLoading,
    handleClickOpen,
    handleClose,
    open,
    setOpen,
    handleResetForm,
    snackbarVisible,
    snackbarMessage,
    closeSnackbar,
    snackColor,
    resource,
    setSelectedFile,
    selectedFile,
    previewURL,
    setPreviewURL,
    deleteDialogShow,
    handleOpenDeleteDialog,
    handleCloseDeleteDialog,
    handleDeleteNomineeFn,
    createFormUpdateLoading
  }
}

export default useOrganisationOwnershipService